import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import RolesTable from './RolesTable';
import { Link } from 'react-router-dom';

const Roles = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Roles" title="Roles" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Roles</H5>
                <Link to="new">
                  <Btn color="primary">New role</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <RolesTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Roles;
